// React Hot Reload does not support stateless function components as of now
/* eslint-disable react/prefer-stateless-function */
import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class App extends Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
    };

    render() {
        return (
            <div>
                { this.props.children }
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/screens/app/index.js
 **/